import { render, staticRenderFns } from "./PlusSvg.vue?vue&type=template&id=8476a1ca&"
import script from "./PlusSvg.vue?vue&type=script&lang=js&"
export * from "./PlusSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports